<template>
  <div id="contactModal" class="modal fade hz-modal-default" tabindex="-1" role="dialog" aria-labelledby="contactModalLabel'" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
      <form class="modal-content" @submit.prevent="onSubmit">
        <div class="modal-header border-none">
          <h5 class="modal-title" id="contactModalLabel" style="display: inline-block">문의하기</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body border-none">
          <div class="form-group">
            <div class="col-xs-12">
              <label>회사명</label>
            </div>
            <div class="col-xs-12">
              <input type="text"
                     class="hz-input-default hz-input-md"
                     data-vv-name="company"
                     v-validate="{required: true}"
                     placeholder="해줌"
                     readonly="readonly"
                     v-model="data['comp_name']">
              <p class="is-invalid-text">{{ errors.first('company') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>담당자명</label>
            </div>
            <div class="col-xs-12">
              <input type="text"
                     class="hz-input-default hz-input-md"
                     data-vv-name="name"
                     v-validate="{required: true}"
                     placeholder="홍길동"
                     v-model="data['name']">
              <p class="is-invalid-text">{{ errors.first('name') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>담당자 연락처</label>
            </div>
            <div class="col-xs-12">
              <input-phone :class="['hz-input-default', 'hz-input-md', {'is-invalid': errors.first('contact')}]"
                           data-vv-name="contact"
                           v-validate="{required: true}"
                           :placeholder="'010-0000-0000'"
                           v-model="data['contact']"
              >
              </input-phone>
              <p class="is-invalid-text">{{ errors.first('contact') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>담당자 이메일</label>
            </div>
            <div class="col-xs-12">
              <input type="text"
                     class="hz-input-default hz-input-md"
                     data-vv-name="email"
                     v-validate="{required: true, email: true}"
                     placeholder="haezoom@hazoom.com"
                     v-model="data['email']">
              <p class="is-invalid-text">{{ errors.first('email') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>문의유형</label>
            </div>
            <div class="col-xs-12">
              <drop-down-list :class="['hz-dropdownlist-md']"
                              data-vv-name="inquiryType"
                              v-validate="{required: true}"
                              :dataUrl="categoryUrl"
                              v-model="data['category']"></drop-down-list>
              <p class="is-invalid-text">{{ errors.first('inquiryType') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>문의내용</label>
            </div>
            <div class="col-xs-12">
                <textarea id="inquiryMemo"
                          class="hz-input-default"
                          rows="10"
                          data-vv-name="inquiryMemo"
                          v-validate="{required: true}"
                          placeholder=""
                          v-model="data['message']"></textarea>
              <p class="is-invalid-text">{{ errors.first('inquiryMemo') }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer text-align-center border-none">
          <button type="submit" class="hz-btn-default hz-btn-md" data-dismiss="modal">취소</button>
          <button type="submit" class="hz-btn-primary hz-btn-md">확인</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import InputPhone from 'common/components/InputPhone'
  import DropDownList from 'common/components/DropDownList'
  import api from '@/api/index'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'contact-modal',
    components: { InputPhone, DropDownList },
    props: {
      contactMessage: {
        type: String,
        default: function () {
          return ''
        }
      }
    },
    data: function () {
      return {
        data: {
          comp_name: '',
          name: '',
          contact: '',
          category: '',
          email: '',
          message: ''
        },
        categoryUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/index/inquery_category/'
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      initData: function () {
        const user = this.user

        // 로그인한 유저정보로 데이터를 초기화 해준다.
        const data = {
          comp_name: user.comp_name,
          name: user.pic_name,
          contact: user.pic_contact,
          category: 'complain',
          email: user.pic_email,
          message: this.contactMessage
        }

        // 문의하기 데이터 초기화
        this.data = data
      },
      show: function () {
        $('#contactModal').modal('show')
      },
      hide: function () {
        $('#contactModal').modal('hide')
      },
      onSubmit: function () {
        const vm = this
        // 모든 폼 필드에 대한 validation 실행
        vm.$validator.validateAll()

        // validation 완료 후 문의하기 API 호출
        vm.$nextTick(function () {
          if (!vm.errors.any()) {
            vm.contactUs()
          }
        })
      },
      contactUs: function () {
        const vm = this
        // 고객문의 API 실행
        api.ContactUs(vm.data, response => {
          if (response.error) {
            console.log(response.source)
            vm.showToastMessage('문의 실패')
            vm.hide()
          } else {
            vm.showToastMessage('문의 완료')
            vm.hide()
          }
        })
      }
    },
    mounted: function () {
      $('#contactModal').on('show.bs.modal', () => {
        this.initData()
        this.errors.clear()
        $(this.$el).find('.is-invalid').removeClass('is-invalid')
      })

      // 문의내용 placeholder Text Set
      document.getElementById('inquiryMemo').placeholder = '개선/불편사항을 상세히 기재해주세요.\n1.검토주소(지역):\n2.내용:'
    },
    beforeDestroy: function () {
      $('#contactModal').off('show.bs.modal')
    }
  }
</script>

<style lang="scss" scoped>
  #contactModal {
    .form-group {
      margin: 0 0 16px 0;
      overflow: hidden;
      .col-xs-12 {
        padding: 0;
        input {
          width: 100%;
        }
      }
      textarea {
        width: 100%;
        padding: 8px 16px;
      }
    }

    .is-invalid-text {
      margin: 0;
      line-height: 14px;
    }

    .modal-footer {
      button { width: 100px; }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ContactModal.vue